import { makeRoute } from "@/lib/makeRoute";
export const Route = makeRoute("/en/about", "en", "about");
